import { IntakePage } from "./pages/IntakePage.js";
import { DocumentsPage } from "./pages/DocumentsPage.js";

const DOCUMENTS_PATH = /^\/documents\/([A-Za-z0-9_-]+)\/?$/;

export function App() {
  const match = DOCUMENTS_PATH.exec(window.location.pathname);
  if (match?.[1]) return <DocumentsPage token={match[1]} />;
  return <IntakePage />;
}
